export const isAvailable: Record<"ENABLE" | "DISABLE", number> = {
  //0:不可選   1:可選
  ENABLE: 1,
  DISABLE: 0,
};
